const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class Barbarians extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.Barbarians,
            "If the civilzations with the most culture points is one of the two weakest civilizations it loses 1 population.",
            {}
        )
    }
}

module.exports = Barbarians;